import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/modules/authentication/context/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen gap-2">
        <div className="animate-spin rounded-full flex items-center justify-center p-1 size-8 bg-primary">
          <svg
            width="20"
            height="13"
            viewBox="0 0 20 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.40741 0C0.630118 0 0 0.692893 0 1.54762V9.05357C0 11.2331 1.6068 13 3.58889 13L11.9259 12.9226C12.7032 12.9226 13.3333 12.2298 13.3333 11.375V3.79169C13.3333 1.61214 11.4265 2.68618e-05 9.44444 2.68618e-05L1.40741 0Z"
              fill="white"
            />
            <path
              d="M15.2358 2.9549C14.7328 3.43976 14.4444 4.13954 14.4444 4.87503V8.01591C14.4444 8.7514 14.7328 9.45118 15.2358 9.93604L18.3653 12.6235C19.0022 13.2374 20 12.7401 20 11.8089V1.22976C20 0.298508 19.0022 -0.198754 18.3654 0.415158L15.2358 2.9549Z"
              fill="white"
            />
          </svg>
        </div>
        <span className="text-gray-600 text-sm">Đang tải...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
